import { useState } from "react";
import { Outlet } from "react-router-dom";

export default function Carbon() {
  const [filterParams, setFilterParams] = useState({}); // 查詢參數
  const [itemObj, setItemObj] = useState({}); // 設定當前點了table哪一筆tr物件(CRUD)
  const [action, setAction] = useState(""); // 設定當前是做哪個動作(CRUD)
  const [currentStatus, setCurrentStatus] = useState({}); // 設定當前是點了返回鍵還是確定按鈕返回是否要重抓查詢畫面資料
  const [tab1Action, setTab1Action] = useState(""); // 設定當前是做哪個動作(CRUD)
  const [reportListObj, setReportListObj] = useState({}); // 設定當前選了哪幾筆報告書
  const [flowStep, setFlowStep] = useState(0);

  return (
    <Outlet
      context={{
        filterParams,
        setFilterParams,
        itemObj,
        setItemObj,
        action,
        setAction,
        currentStatus,
        setCurrentStatus,
        tab1Action,
        setTab1Action,
        reportListObj,
        setReportListObj,
        flowStep,
        setFlowStep,
      }}
    />
  );
}
